export const siteMeta = {
  name: "爆料91",
  slogan: "爆料91专区 · 栏目合集全收录",
  tagline: "一个入口，看齐爆料91全部内容",
  description:
    "爆料91是面向泛娱乐读者的内容聚合门户，把栏目、频道、板块里的内容统一归拢成合集。进入爆料91专区，一个页面对应整块专区，省得来回翻。",
  email: "contact@baoliao91.example",
  cooperationEmail: "media@baoliao91.example",
  foundedYear: "2019",
  editTeam: "爆料91内容编辑组",
  stats: [
    { label: "收录专区", value: "26", unit: "个" },
    { label: "整理合集", value: "1,480", unit: "期" },
    { label: "累计阅读", value: "3,600", unit: "万" },
    { label: "每日更新", value: "40", unit: "条起" },
  ],
  principles: [
    {
      title: "只做整理，不做搬运",
      content:
        "每个专区下的合集都重新编排过，标注出处、补齐脉络，而不是把原文原样贴一遍。读者花两分钟就能判断值不值得往下看。",
    },
    {
      title: "结构优先于数量",
      content:
        "与其堆更多条目，不如把分类做得更清楚。专区的划分标准和合集的排序逻辑都写在页面上，读者随时知道自己在看哪一块。",
    },
    {
      title: "不碰个人隐私",
      content:
        "我们整理的是公开传播的作品与话题内容，不涉及任何具体个人的私人信息。站内出现的作品与人物均为设定内容，不指向现实中的任何个人。",
    },
    {
      title: "更新节奏透明",
      content:
        "每个合集都会标注最近整理时间。热度高的方向每天更新，内容稳定的方向按周维护，节奏写得明明白白。",
    },
  ],
  testimonials: [
    {
      name: "小鹿",
      role: "追剧读者",
      content:
        "以前找一部剧的讨论要翻好几个地方，现在直接进热剧速递专区，名场面和伏笔都排好了，省了好多时间。",
    },
    {
      name: "阿泽",
      role: "综艺爱好者",
      content:  "综艺吃瓜专区把名梗单独拎出来了，想找某个桥段不用再翻整季，这个整理方式真的很省事。",
    },
    {
      name: "Wendy",
      role: "内容运营",
      content:
        "我主要用网络热梗专区跟话题，每个词的出处和扩散阶段都标了，判断值不值得跟进一目了然。",
    },
  ],
};